import React, { useEffect, useMemo } from 'react';
import Collapsible from 'react-collapsible';
import { collapsibleSettings } from "../../helpers/Helpers";
import { classNamesPrefixed } from "../../../helpers/CoreHelpers";
import InputWrap from "./InputWrap";
import SelectField from './SelectField';
import ToggleField from './ToggleField';

const DISPLAY_COUNT_OPTIONS = [{
    title: '5',
    id: 5
}, {
    title: '10',
    id: 10
}, {
    title: '15',
    id: 15
}];

const DEFAULT_VALUES = Object.freeze({
    displayCount: 5,
    pagination: true
});

export const NewsListingAttributesField = (props) => {
    const { input, omitCollapsible, label, expanded } = props;

    useEffect(() => {
        if (typeof input.value === 'string') {
            input.onChange({ ...DEFAULT_VALUES });
        }
    }, []);

    const onDisplayCountChangeHandler = (displayCount) => {
        input.onChange({
            ...input.value,
            displayCount
        });
    };

    const onPaginationEnableToggleHandler = (_, pagination) => {
        input.onChange({
            ...input.value,
            pagination
        });
    };

    const displayCountValue = useMemo(() => {
        if (input.value.displayCount) {
            return DISPLAY_COUNT_OPTIONS.find(o => o.id === input.value.displayCount);
        }

        return DISPLAY_COUNT_OPTIONS.find(o => o.id === DEFAULT_VALUES.displayCount);
    }, [input.value.displayCount])

    const content = (
        <InputWrap label={null} {...props}>
            <SelectField
                label="Display count"
                defaultValue={displayCountValue}
                omitCollapsible
                afterOnChange={onDisplayCountChangeHandler}
                items={DISPLAY_COUNT_OPTIONS}
            />
            <br />
            <ToggleField
                {...props}
                inputType="toggle"
                label="Pagination enable"
                type="boolean"
                input={{
                    value: input.value.pagination,
                    onChange: onPaginationEnableToggleHandler
                }}
                defaultValue
                omitCollapsible
            />
        </InputWrap>
    );

    if (omitCollapsible) {
        return <div>{content}</div>
    }

    return (
        <Collapsible open={expanded} {...collapsibleSettings} trigger={<label className={classNamesPrefixed({ "trigger__label": true })}>{label ? label : 'Image'}</label>}>
            {content}
        </Collapsible>
    );
};

export default NewsListingAttributesField;



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/NewsListingAttributesField.js